import { createEntityAdapter } from '@reduxjs/toolkit';
import { TournamentBracket } from 'modules/championship/domain/interfaces/tournament-bracket';

const bracketsAdapter = createEntityAdapter<TournamentBracket>({
  selectId: (bracket) => bracket.id,
  sortComparer: (a, b) => a.rank - b.rank,
});

export default bracketsAdapter;
